import { CheckIcon, MinusIcon } from '@heroicons/react/24/outline';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import type { ComponentProps } from 'react';

import { cn } from '@/shared/lib/utils';

type CheckboxProps = ComponentProps<typeof CheckboxPrimitive.Root>;

export const Checkbox = ({ className, ...props }: CheckboxProps) => (
  <CheckboxPrimitive.Root
    className={cn(
      'peer size-4 shrink-0 rounded border border-solid transition-all',
      'border-border-strength1 bg-surface-base shadow-xs',
      'data-[state=checked]:border-border-accent data-[state=checked]:bg-[#059669]',
      'data-[state=indeterminate]:border-border-accent data-[state=indeterminate]:bg-[#059669]',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-text-inverse">
      {props.checked === 'indeterminate' ? (
        <MinusIcon className="size-3" />
      ) : (
        <CheckIcon className="size-3" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);
